import cn from 'classnames';

import { Tooltip } from 'components/tooltip-v2';
import { useInnerWidth } from 'hooks';
import { List } from 'layouts/content/list';

import css from './guidelinesTooltip.module.css';

const GuidelinesTooltip = () => {
  const innerWidth = useInnerWidth(true);

  const tooltipContent = (
    <>
      <p className="font-weight-600">We appreciate your valuable input in our community.</p>
      <p className="z-font-14 z-leading-22px">
        {`Your feedback plays a pivotal role in assisting others to make informed decisions about various job opportunities and companies.`}
      </p>
      <p className="z-font-14 z-leading-22px">
        {`We kindly ask you to adhere to our Community Guidelines, refraining from posting:`}
      </p>
      <List className="z-font-14 z-leading-22px">
        <li>Aggressive or discriminatory language</li>
        <li>Profanity</li>
        <li>Confidential information</li>
      </List>
      <p className="z-font-14 z-leading-22px z-mb-0 z-mt-16">
        {`Your cooperation helps maintain a reliable platform for job seekers and company explorers. For a more comprehensive understanding of our guidelines, please refer to our Community Guidelines section.`}
      </p>
    </>
  );

  return (
    <Tooltip delayDuration={150}>
      <Tooltip.Trigger>
        <span
          className="icon-info-icon cursor-pointer"
          style={{
            color: 'rgb(125, 135, 143)',
            verticalAlign: 'middle',
          }}
        />
      </Tooltip.Trigger>
      <Tooltip.Content
        className={cn(css.popper, css.content, 'bg-white z-p-20 border rounded text-black')}
        side={innerWidth <= 768 ? 'bottom' : 'right'}
        align="start"
        collisionPadding={10}
        arrowPadding={20}
        arrowClassName={css.arrow}
      >
        {tooltipContent}
      </Tooltip.Content>
    </Tooltip>
  );
};

export default GuidelinesTooltip;
